<template>
     <vxe-tabs>
      <vxe-tab-pane title="出仓记录" name="1">
        <template #default> <vxe-table
              border
              show-overflow
              show-header-overflow
              :row-config="{ isCurrent: true, isHover: true }"
              :data="OutTableData"
            >
              <vxe-table-column type="seq" width="60"></vxe-table-column>
              <vxe-table-column field="ckdh" title="销售单号" width="160"></vxe-table-column>
              <vxe-table-column field="khmc" title="客户名称" ></vxe-table-column>
              <vxe-table-column field="rq" title="日期" width="160" :formatter="formatDate"></vxe-table-column>
              <vxe-table-column field="dj" title="单价" width="50"></vxe-table-column>
              <vxe-table-column field="sl" title="数量" width="50"></vxe-table-column>
            </vxe-table></template>
      </vxe-tab-pane>
      <vxe-tab-pane title="进仓记录" name="2">
        <template #default>
            <vxe-table
              border
              show-overflow
              show-header-overflow
              :row-config="{ isCurrent: true, isHover: true }"
              :data="InTableData"
            >
              <vxe-table-column type="seq" width="60"></vxe-table-column>
              <vxe-table-column field="rkdh" title="进仓单号" width="160"></vxe-table-column>
              <vxe-table-column field="gsmc" title="供货商名称" width="120"></vxe-table-column>
              <vxe-table-column field="rq" title="日期" width="160" :formatter="formatDate"></vxe-table-column>
              <vxe-table-column field="dj" title="单价" width="50"></vxe-table-column>
              <vxe-table-column field="sl" title="数量" width="50"></vxe-table-column>
            </vxe-table>
        </template>
      </vxe-tab-pane>
      
    </vxe-tabs>
</template>
<script setup >
import { ref,defineProps,onMounted } from 'vue'
import { getInStockRecord,getOutStockRecord } from '../utils/ProductHelper'
const props = defineProps({
  Product: {
    type: String,
    default: () => ''
  },
})
// 格式化函数，params 里有 cellValue、row 等
const formatDate = ({ cellValue }) => {
  if (!cellValue) return ''
  const date = new Date(cellValue)
  const y = date.getFullYear()
  const m = String(date.getMonth() + 1).padStart(2, '0')
  const d = String(date.getDate()).padStart(2, '0')
  return `${y}-${m}-${d}`
}
const InTableData = ref([])
const OutTableData = ref([])
onMounted(async () => {
   
  if(props.Product){
    if(props.Product !== ''){
     InTableData.value = await getInStockRecord(props.Product)
     OutTableData.value = await getOutStockRecord(props.Product)
     console.log(InTableData.value)
     console.log(OutTableData.value)
  }
}
})
</script>